/**
 * Module-singleton handoff for "open this condition's settings as soon as its
 * card mounts" — needed when an action (Duplicate) creates a condition whose
 * card does not exist in the tree yet, so there is nothing to call `.open()`
 * on directly. A React ref can't be shared across sibling component
 * instances, so this is a plain mutable box instead, consumed once.
 */
let pendingConditionId: string | undefined;

export function requestOpenOnMount(conditionId: string) {
  pendingConditionId = conditionId;
}

export function consumePendingOpen(conditionId: string): boolean {
  if (pendingConditionId === conditionId) {
    pendingConditionId = undefined;
    return true;
  }
  return false;
}
